import React, { Component } from 'react';
import _ from 'lodash';
import './css/linkedin.scss';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';
import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import classnames from 'classnames';
import importAll from '../../utils/helpers';
import LanguageSelector from '../header/languageSelector';
import homescreenImage from '../../assets/images/whitelabel/homescreen.png';

const images = importAll(require.context('../../assets/images/hero-invitation', false, /\.(png|jpe?g|svg)$/));
const badges = importAll(require.context('../../assets/images/badges', false, /\.(png|jpe?g|svg)$/));

const deepLinkUrl = () => {
  const fullUrl = window.location.href;
  const { protocol } = window.location;
  return fullUrl.replace(protocol, 'workero:');
};

const isUrlMobileWithRequest = () => {
  return (
    isMobile &&
    _.has(window, 'location.pathname') &&
    _.isString(window.location.pathname) &&
    !_.isEmpty(window.location.pathname.replace('/', ''))
  );
};

class IsMobile extends Component {
  constructor(props) {
    super(props);
    this.deeplinkRef = null;
    this.setDeeplinkRef = element => {
      this.deeplinkRef = element;
    };
    this.state = {
      featureUnavailableOnMobile: false,
    };
  }

  componentDidMount() {
    if (this.deeplinkRef && isUrlMobileWithRequest()) {
      // this.deeplinkRef.click();
    }
    const urlSlug = window.location.pathname.split('/')[1];
    if (urlSlug === 'meeting') {
      this.setState({ featureUnavailableOnMobile: true });
    }
  }

  buildUrlMobileRequestLink() {
    if (!isUrlMobileWithRequest()) {
      return null;
    }
    return (
      <div style={{ opacity: 0, position: 'absolute', width: 0, height: 0 }}>
        <a ref={this.setDeeplinkRef} href={deepLinkUrl()}>
          Deeplink Url
        </a>
      </div>
    );
  }

  render() {
    const { featureUnavailableOnMobile } = this.state;
    const { translations } = this.props;
    const homescreenTranslations = _.get(translations, 'wmsHomescreen', {});
    const footerTranslations = _.get(translations, 'openAuth.footer', {});
    const privacyUrl = 'https://www.iubenda.com/privacy-policy/47429114';
    const cookieUrl = 'https://www.iubenda.com/privacy-policy/47429114/cookie-policy';

    let appBadgeLink = null;
    if (isAndroid) {
      appBadgeLink = (
        <a href="https://play.google.com/store/apps/details?id=com.workero.corporate">
          <img alt="" src={badges['badgeAndroid.png']} />
        </a>
      );
    } else if (isIOS) {
      appBadgeLink = (
        <a href="https://apps.apple.com/us/app/workero-corporate/id1561813863#?platform=iphone">
          <img alt="" src={badges['badgeApple.png']} />
        </a>
      );
    } else {
      appBadgeLink = (
        <div>
          <a href="https://play.google.com/store/apps/details?id=com.workero.corporate">
            <img alt="" src={badges['badgeAndroid.png']} />
          </a>
          <div />
          <a href="https://apps.apple.com/us/app/workero-corporate/id1561813863#?platform=iphone">
            <img alt="" src={badges['badgeApple.png']} />
          </a>
        </div>
      );
    }

    return (
      <Scrollbars>
        {this.buildUrlMobileRequestLink()}
        <div className={classnames(`${!featureUnavailableOnMobile ? 'wmsHomescreen__body' : ''}`, 'body-landing')}>
          {featureUnavailableOnMobile ? (
            <div className="container-fluid imgBackground">
              <div className="row">
                <div className="col-12 centerSection">
                  <div className="row">
                    <div className="col-12 custom30 custom60 text-center">
                      <div className="icon-holder">
                        <div className="logo positionCenter">
                          <img alt="" className="conditionalLogo" src="#" />
                          <img alt="" src={images['workero@3x.png']} />
                        </div>
                      </div>

                      <p className="w-p">
                        <span className="white yellow">
                          This feature is currently unavailable on mobile. Please enter our desktop version to be able to use it.
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 custom30 custom60 " />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="wmsHomescreen__container wmsHomescreen__container__mobile">
                <div className="wmsHomescreen__header">
                  <div className="wmsHomescreen__logo" />
                  <LanguageSelector />
                </div>
                <div className="wmsHomescreen__main-content__mobile">
                  <div className="wmsHomescreen__role-item">
                    <span className="wmsHomescreen__role-type">{_.get(homescreenTranslations, 'asAUser', 'As a user')}</span>
                    <span className="wmsHomescreen__role-text">
                      {_.get(
                        homescreenTranslations,
                        'userText',
                        'If you have been invited by your company to use the workplace management software then click here. If not, please see with your company admin to invite you.'
                      )}
                    </span>
                    <span className="wmsHomescreen__role-text">
                      <span className="wmsHomescreen__role-text--highlighted">
                        {`${_.get(homescreenTranslations, 'downloadOurApp', 'Download our app')} `}
                      </span>
                      {_.get(homescreenTranslations, 'toLoginAsAUser', 'to login as a user:')}
                    </span>
                    {appBadgeLink}
                  </div>
                  <div className="wmsHomescreen__role-item">
                    <span className="wmsHomescreen__role-type">{_.get(homescreenTranslations, 'asAnAdmin', 'As an admin')}</span>
                    <span className="wmsHomescreen__role-text">
                      {_.get(
                        homescreenTranslations,
                        'adminText',
                        'If you have been invited as an admin for your company, please login here. If you want to be added as admin on your company account, please see with your company admin to invite you.'
                      )}
                    </span>
                    <span className="wmsHomescreen__role-text--highlighted">
                      {_.get(homescreenTranslations, 'onlyAccessibleThroughDesktop', 'Only accessible through desktop')}
                    </span>
                  </div>
                </div>
                <p
                  className="wmsHomescreen__contact-us"
                  dangerouslySetInnerHTML={{
                    __html: _.get(
                      homescreenTranslations,
                      'ifYouHaveQuestions',
                      'If you have questions, please send an email to <a href=mailto:wmssupport@workero.com>wmssupport@workero.com</a> or talk to us through the online chat.'
                    ),
                  }}
                />
                <a href={`${window.__env.public_site}`} target="_blank" className="wmsHomescreen__button" rel="noreferrer">
                  {_.get(homescreenTranslations, 'visitOurWebsite', 'Visit our website')}
                </a>
                <img src={homescreenImage} className="wmsHomescreen__image" alt="Homescreen" />
              </div>
            </>
          )}
          <div className="row">
            <div className="col-md-8 offset-md-2 text-center footer">
              <div className="intro">
                <span className="service">{_.get(footerTranslations, 'serviceProvidedBy', 'serviceProvidedBy')}</span>
                <span className="copyright active">© Workero {moment().format('YYYY')}</span>

                <div className="icon-holder">
                  <div className="workero-logo" />
                </div>
              </div>

              <div className="list-inline-dot">
                <a href={privacyUrl} target="_blank" rel="noopener noreferrer">
                  {_.get(footerTranslations, 'privacy', 'privacy')}
                </a>
                <a href={cookieUrl} target="_blank" rel="noopener noreferrer">
                  {_.get(footerTranslations, 'cookie', 'cookie')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </Scrollbars>
    );
  }
}

export default IsMobile;
